import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// DNS prefetch for third-party domains
const dnsFb = document.createElement('link');
dnsFb.rel = 'dns-prefetch';
dnsFb.href = 'https://connect.facebook.net';
document.head.appendChild(dnsFb);
// Preconnect to image CDN FIRST for faster resource discovery
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// Preload hero image (LCP element) — highest priority, before any scripts
const link = document.createElement('link');
link.rel = 'preload';
link.as = 'image';
link.type = 'image/png';
link.setAttribute('fetchpriority', 'high');
link.setAttribute('imagesizes', '(max-width: 768px) 75vw, 512px');
link.href = 'https://cdn.magicpatterns.com/uploads/nJ6227LTvBcXZFid5u8iHs/MOCAP_100_CITAS.png';
document.head.appendChild(link);
// Render app immediately
render(<App data-id="element-270" />, document.getElementById('root'));
// Meta Pixel — load ONLY after page is fully loaded to never compete with LCP
const loadPixel = () => {
  const _w = window as any;
  if (!_w.fbq) {
    const fbq: any = _w.fbq = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!_w._fbq) _w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
  }
  const fbScript = document.createElement('script');
  fbScript.async = true;
  fbScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(fbScript);
  _w.fbq('init', '885866990629991');
  _w.fbq('track', 'PageView');
};
if (document.readyState === 'complete') {
  setTimeout(loadPixel, 100);
} else {
  window.addEventListener('load', () => setTimeout(loadPixel, 100), {
    once: true
  });
}